export default "__VITE_ASSET__dORKQSWM__"